module.exports = __webpack_public_path__ + "static/media/img_40.233e9add.png";